<template>
    <v-btn :width="btnSize"
           :height="btnSize"
           class="no-bg-hover"
           depressed
           :ripple="false"
           @click.stop.prevent="onFavourite"
           icon
    >
        <v-icon :size="size" :color="color" style="stroke: white">
            {{ mdiHeart }}
        </v-icon>
    </v-btn>
</template>

<script>
import { mdiHeart } from "@mdi/js";

export default {
    name: "ProductHeartButton",
    props: {
        productId: {
            required: true,
        },
        size: {
            default: 26,
        }
    },
    computed: {
        isFavourite() {
            return this.$store.state.favourites.favourites.includes(this.productId);
        },
        btnSize() {
            return this.size + 4
        },
        color() {
            return this.isFavourite ? 'error' : null;
        },
        mdiHeart() {
            return mdiHeart
        },
    },
    methods: {
        onFavourite() {
            if (this.isFavourite) {
                this.$store.dispatch('favourites/deleteFavourite', this.productId)
            } else {
                this.$store.dispatch('favourites/addFavourite', {product_id: this.productId})
            }
        }
    }
}
</script>

<style>
.no-bg-hover:focus::before {
    background-color: transparent !important;
}
.no-bg-hover:hover::before {
    background-color: transparent !important;
}
</style>